const Urls = {
    frontend: (process.env.NODE_ENV === 'development') ? 'http://127.0.0.1:3000' : "https://www.likedsongsmanager.com",
    backend: (process.env.NODE_ENV === 'development') ? 'http://127.0.0.1:5205' : "https://www.likedsongsmanager.com" 
}

export default Urls;